import Loading from '@/components/widgets/Loading'
import { useUser } from '@/components/widgets/UserProvider'
import { useState, useEffect, useRef } from 'react'
// import { useInView } from 'react-intersection-observer'

const ProposalImageAnim = () => {
  const [showOverlay, setShowOverlay] = useState(false)
  const [imageFullyVisible, setImageFullyVisible] = useState(false)
  const { userPageLoading } = useUser()
  const [hasAnimated, setHasAnimated] = useState(false)

  console.log({ showOverlay, hasAnimated })

  // const { ref, inView } = useInView({
  //   triggerOnce: false,
  //   threshold: 0,
  // })

  // useEffect(() => {
  //   if (inView) {
  //     const interval = setInterval(() => {
  //       setShowOverlay((prev) => !prev)
  //     }, 1700)
  //     return () => clearInterval(interval)
  //   } else {
  //     setShowOverlay(false)
  //     setImageFullyVisible(false)
  //     setHasAnimated(false)
  //   }
  // }, [inView])

  // useEffect(() => {
  //   if (showOverlay) {
  //     setImageFullyVisible(true)
  //   } else {
  //     setImageFullyVisible(false)
  //   }
  // }, [showOverlay])

  // useEffect(() => {
  //   if (imageFullyVisible && !hasAnimated) {
  //     setHasAnimated(true)
  //   }
  // }, [imageFullyVisible, hasAnimated])

  return userPageLoading ? (
    <Loading classes='flex-grow flex relative max-h-screen sm:min-h-[645px] mt-[15px] bg-[rgba(128,128,128,0.3)] !text-white' />
  ) : (
    <div className='relative w-full h-[394px] sm:h-[689px]'>
      <div
        className="absolute inset-0 w-full h-full bg-[url('/engagement/proposal-section-banner.svg')] bg-cover flex justify-center items-center"
        style={{ backgroundPosition: '80% 40%' }}
      >
        <div className='absolute inset-0 lg:mt-[50px] mt-[40px] flex justify-center'>
          <div className="bg-[url('/engagement/pc_banner_logo.png')] bg-cover lg:w-[79px] w-[40px] lg:h-[114px] h-[60px]"></div>
        </div>
        <div className='z-[9] mt-[35px]'>
          {!hasAnimated && (
            <div
              className={`${
                showOverlay ? 'opacity-0' : 'opacity-100'
              } text-center z-10 transition-opacity duration-[1200ms]`}
            >
              <span className='text-[24px] md:text-[50px] font-cambonRegular'>
                The
                <div
                  className={`relative w-full flex justify-center transition-transform ${
                    showOverlay ? 'duration-[1500ms]' : 'duration-[300ms]'
                  }`}
                  style={{
                    transform: showOverlay
                      ? 'translateX(30%)'
                      : 'translateX(0)',
                  }}
                >
                  <span className='text-[50px] md:text-[140px] font-cambonLightItalic inline-block'>
                    Proposal
                  </span>
                </div>
                Collection
              </span>
            </div>
          )}
        </div>
      </div>

      <div className='relative top-[50%]'>
        <div className='absolute inset-0 flex justify-center items-center z-10'>
          <img
            src='/engagement/pc_bg1.png'
            alt='Proposal Collection'
            className={`w-auto lg:h-[800px] md:h-[600px] h-[400px] lg:object-contain object-fill transition-all duration-[1200ms] transform ${
              hasAnimated ? 'opacity-100 scale-100' : 'opacity-0 scale-[0.5]'
            }`}
            style={{
              transformOrigin: 'center',
              transitionDuration: hasAnimated ? '1500ms' : '300ms',
            }}
          />
        </div>
        <div
          className={`${
            hasAnimated ? 'opacity-100 scale-100' : 'opacity-0 scale-[0.5]'
          } absolute lg:top-[0] top-[-65px] w-full text-[#fff] flex justify-center items-center z-[999] lg:text-[16px] text-[14px] font-[300] leading-[29px] font-barlowMedium uppercase transition-all duration-[1200ms] transform`}
        >
          <span className={`text-justify max-w-[450px] mx-[30px]`}>
            Capture the joy &nbsp;&nbsp;&nbsp; of your proposal with a{' '}
            <span className='!font-[500]'>
              ring that tells your love story.
            </span>
            <br /> Begin your forever with a{' '}
            <span className='!font-[500]'>
              lab-grown diamond engagement ring
            </span>{' '}
            crafted to the highest standard.
          </span>
        </div>
      </div>

      <div className='absolute top-0 bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent'></div>
    </div>
  )
}

export default ProposalImageAnim
